import { useState, useEffect } from 'react';
import { Lock, Loader2 } from 'lucide-react';

/**
 * PIN-Sperre für den Admin-Bereich.
 * Zusätzliche Sicherheitsebene NACH dem Login. Die PIN wird nur für die
 * aktuelle Browser-Session gespeichert (sessionStorage) – nach dem Schließen
 * des Tabs muss sie neu eingegeben werden.
 *
 * Änderung der PIN: siehe REACT_APP_ADMIN_PIN oder Fallback unten.
 */
const ADMIN_PIN = process.env.REACT_APP_ADMIN_PIN || '58840';
const STORAGE_KEY = 'farbwelt_admin_pin_ok';

export default function AdminPinGate({ children }) {
  const [ok, setOk] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') setOk(true);
    } catch (_) {}
    setChecking(false);
  }, []);

  const submit = (e) => {
    e?.preventDefault?.();
    if (pin === ADMIN_PIN) {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
      setOk(true);
      setError('');
    } else {
      setError('Falsche PIN. Bitte erneut versuchen.');
      setPin('');
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#9B1B30]" />
      </div>
    );
  }
  if (ok) return children;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f8f5f0] to-[#efe6dd] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm border border-gray-100">
        <div className="w-16 h-16 rounded-full bg-[#9B1B30]/10 flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-[#9B1B30]" />
        </div>
        <h2 className="text-xl font-bold text-center text-gray-900 mb-1">Admin-Bereich</h2>
        <p className="text-sm text-gray-500 text-center mb-6">Bitte PIN eingeben, um fortzufahren.</p>
        <form onSubmit={submit} className="space-y-3">
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            autoFocus
            value={pin}
            maxLength={12}
            onChange={(e) => { setPin(e.target.value.replace(/[^0-9]/g, '')); setError(''); }}
            placeholder="PIN"
            data-testid="admin-pin-input"
            className="w-full text-center text-2xl tracking-[0.4em] font-mono border-2 border-gray-200 rounded-xl px-4 py-4 focus:border-[#9B1B30] focus:outline-none"
          />
          {error && <p className="text-sm text-red-600 text-center">{error}</p>}
          <button
            type="submit"
            disabled={pin.length < 4}
            data-testid="admin-pin-submit"
            className="w-full bg-[#9B1B30] text-white rounded-xl py-3 font-semibold hover:bg-[#7a1525] transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Entsperren
          </button>
        </form>
      </div>
    </div>
  );
}
